import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Landing from "../pages/landing";
import Projects from "../pages/projects";
import ProjectDetails from "../pages/projectDetails";
// import LiquidityLock from '../pages/liquidityLock';
// import CreateLaunchpad from "../pages/createLaunchpad";

/**
 * The router is imported in app.jsx
 *
 * Our site just has two routes in it–Home and About
 * Each one is defined as a component in /pages
 * We use Switch to only render one route at a time https://github.com/molefrog/wouter#switch-
 */

/*export default () => (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/about" component={About} />
    </Switch>
);*/

//import Landing from '../pages/Landing';
//import Projects from '../pages/Projects';
//import ProjectDetails from '../pages/ProjectDetails';

// import Admin from '../pages/Admin';
// import PreSale from '../pages/PreSale';
// import Tokenowner from '../pages/Tokenowner';
// import PreSaleDetail from '../pages/PreSaleDetail';

//import Metamask from '../components/InstallMetaMask';

class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/">
          <Landing state={this.props.state} />
        </Route>

        {/* <Route exact path='/presales'>
          <Admin state={this.props.state} setState={this.props.setState} />
        </Route>
        <Route exact path='/presale/:address'>
          <PreSale state={this.props.state} setState={this.props.setState} />
        </Route> */}

        <Route exact path="/projects">
          <Projects config={this.props.config} appStatus={this.props.state} />
        </Route>

        <Route exact path="/project/:presaleAddress">
          <ProjectDetails
            appStatus={this.props.state}
            config={this.props.config}
          />
        </Route>

        {/* <Route exact path="/lock">
          <LiquidityLock
            // state={this.props.state}
            // setState={this.props.setState}
            appStatus={this.props.state}
            config={this.props.config}
          />
        </Route> */}

        {/* <Route exact path="/createLaunchpad">
          <CreateLaunchpad
            // state={this.props.state}
            // setState={this.props.setState}
            appStatus={this.props.state}
            config={this.props.config}
          />
        </Route> */}

        {/* <Route exact path='/tokenowner'>
          <Tokenowner state={this.props.state} setState={this.props.setState} />
        </Route> */}

        {/* <Route exact path='/presaledetail/:address'>
          <PreSaleDetail
            state={this.props.state}
            setState={this.props.setState}
          />
        </Route> */}

        {/*<Route exact path='/metamask'>
          <Metamask state={this.props.state} setState={this.props.setState} />
        </Route>*/}
      </Switch>
    );
  }
}

export default Routes;
